const teamVehicles = [
  {
    teamId: "3623050e-5956-48af-8494-a9ff3ad159cd",
    teamName: "DefaultTeam",
    vehicles: [
      {
        vehicleId: "9102095",
        vehicleType: "Creativity",
      },
      {
        vehicleId: "9178202",
        vehicleType: "Effort",
      },
      {
        vehicleId: "9414060",
        vehicleType: "Norland",
      },
    ],
  },
];

export const getTeamVehiclesRespMaritime = (teamId) => {
  if (!teamId) {
    return teamVehicles;
  }

  const res = [];
  teamId.forEach((id) => {
    const team = teamVehicles.filter((team) => team.teamId === id);
    if (team && team.length > 0) {
      res.push(team[0]);
    }
  });
  return res;
};
